import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Page title mapping - maps routes to their respective titles
const PAGE_TITLES = {
  '/': 'Dashboard',
  '/products': 'Products',
  '/variants': 'Variants',
  '/inventory/location': 'Inventory Location',
  '/sale-return': 'Sale & Return',
  '/inventory/pick-list': 'Pick List',
  '/marketplace/amazon': 'Amazon Marketplace',
  '/marketplace/flipkart': 'Flipkart Marketplace',
  '/marketplace/myntra': 'Myntra Marketplace',
  '/marketplace/ajio': 'Ajio Marketplace',
  '/marketplace/nykaa': 'Nykaa Marketplace',
  '/utility': 'Utility',
  '/settings': 'Settings',
  '/logout': 'Logout'
};

// Default title for the application
const DEFAULT_TITLE = 'Inventory Management System';

const PageTitle = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Get the page title for the current route or use the default title
    const pageTitle = PAGE_TITLES[location.pathname] || DEFAULT_TITLE;
    
    // Set the document title
    document.title = `${pageTitle} | ${DEFAULT_TITLE}`;
  }, [location.pathname]);
  
  // This component doesn't render anything, it just updates the document title
  return null;
};

export default PageTitle;
